<template>
  <k-vuelidate-error-extractor :validator="validator">
    <b-form-input
      v-bind="$attrs"
      trim
      :value="value"
      :autocomplete="autocomplete"
      @input="$emit('input', $event)"
      @blur="$emit('blur', $event)"
    ></b-form-input>
  </k-vuelidate-error-extractor>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'basic-text-input',
  inheritAttrs: false,
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  props: {
    value: {
      type: String,
      default: '',
    },
    validator: {
      type: Object,
      default: function() {
        return {};
      },
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
  },
};
</script>
